import { render, staticRenderFns } from "./partsModal.vue?vue&type=template&id=6c5531a8&scoped=true&"
import script from "./partsModal.vue?vue&type=script&lang=js&"
export * from "./partsModal.vue?vue&type=script&lang=js&"
import style0 from "./partsModal.vue?vue&type=style&index=0&id=6c5531a8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5531a8",
  null
  
)

export default component.exports